import Swal from 'sweetalert2';
import { REACT_APP_API_ENDPOINT_REGISTER_BRANDING } from '../../../Domain/Settings/SettingsVariables';

import { Post } from '../../HTTP/Post';

//Feature: ApiRegisterBranding
//Autor: sebastian.molina
//Description: Función que se encarga de consumir el api de registrar marca.
function ApiRegisterBranding(data) {
    const { AxiosPost } = Post()

    const res = AxiosPost(`${REACT_APP_API_ENDPOINT_REGISTER_BRANDING}`, data, true)
        .then((response) => {
            if (response.hasOwnProperty("StatusCode") && response.StatusCode !== 200) {
                Swal.fire({
                  title: response.Message,
                  customClass:{
                    title:'Error'
                  }
                });
                return
              } else {
                return response;
              }
        })
        .catch((error) => {
          Swal.fire({
            title: error.Message,
            customClass:{
              title:'Error'
            }
          });
        });

        return res
}

export default ApiRegisterBranding;